import React from "react";
import bagIcon from "../assets/bag.svg";
import "./BagButton.css";

export default function BagButton({ visible, position = "right" }) {
  const CART_URL = "https://checkout.ghettosymphony.store/cart";
  if (!visible) return null;

  return (
    <a className={`bagBtn bagBtn--${position}`} href={CART_URL} aria-label="Cart">
      <img className="bagBtn__img" src={bagIcon} alt="" />
    </a>
  );
}